import React from "react";
import CaseStudiesBgLanding from "./CaseStudiesBgLanding";
import CaseStudiesHeading from "./CaseStudiesHeading";
import { Box } from "@mui/material";
import CaseStudiesCardSection from "./CaseStudiesCardSection";
import { Helmet } from "react-helmet";

const CaseStudies = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | Case Studies</title>
        <meta
          name="description"
          content="Real impact, real results. Our case studies showcase how we’ve helped businesses cut through complexity, harness data-driven insights, and unlock transformative growth with clarity and confidence."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <CaseStudiesBgLanding />
        <CaseStudiesHeading />
        <CaseStudiesCardSection />
      </Box>
    </>
  );
};

export default CaseStudies;
